<template>
  <button
    type="button"
    v-if="themeOptions.showButtonFullScreen"
    class="v-video-control"
    @click="fullscreen"
  >
    <svg
      v-if="videoState.fullScreen"
      class="icon--pressed"
      role="presentation"
      focusable="false"
    >
      <use xlink:href="#icon-exit-fullscreen"></use>
    </svg>

    <svg
      v-if="!videoState.fullScreen"
      class="icon--pressed"
      role="presentation"
      focusable="false"
      viewBox="0 0 286.84 222.98"
    >
      <use xlink:href="#icon-enter-fullscreen"></use>
    </svg>
  </button>
</template>

<script>
export default {
  inject: ["eventBus"],
  props: {
    videoState: {
      type: Object
    },
    themeOptions: {
      type: Object
    }
  },
  methods: {
    fullscreen() {
      this.eventBus.$emit("video.fullscreen");
    }
  }
};
</script>
